module.exports = __webpack_public_path__ + "img/Jenkins.e4525882.png";